module.exports = __webpack_public_path__ + "img/xinfgz.ca737de0.svg";